import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16",
  fill: "none",
  viewBox: "0 0 14 16"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5 2c-.796 0-1.559.316-2.121.879C2.316 3.44 2 4.204 2 5v4c0 1.326.527 2.598 1.464 3.536C4.402 13.473 5.674 14 7 14s2.598-.527 3.536-1.464C11.473 11.598 12 10.326 12 9V5c0-.265.105-.52.293-.707C12.48 4.105 12.735 4 13 4c.265 0 .52.105.707.293.188.187.293.442.293.707v4c0 .92-.181 1.83-.533 2.679-.352.85-.867 1.62-1.517 2.27-.65.65-1.422 1.166-2.271 1.518C8.829 15.82 7.919 16 7 16c-.92 0-1.83-.181-2.679-.533-.85-.352-1.62-.867-2.27-1.517C1.4 13.3.884 12.528.532 11.679.18 10.829 0 9.919 0 9V5c0-1.326.527-2.598 1.464-3.536C2.402.527 3.674 0 5 0s2.598.527 3.536 1.464C9.473 2.402 10 3.674 10 5v4c0 .796-.316 1.559-.879 2.121C8.56 11.684 7.796 12 7 12s-1.559-.316-2.121-.879C4.316 10.56 4 9.796 4 9V5c0-.265.105-.52.293-.707C4.48 4.105 4.735 4 5 4c.265 0 .52.105.707.293C5.895 4.48 6 4.735 6 5v4c0 .265.105.52.293.707.187.188.442.293.707.293.265 0 .52-.105.707-.293C7.895 9.52 8 9.265 8 9V5c0-.796-.316-1.559-.879-2.121C6.56 2.316 5.796 2 5 2z",
  "clip-rule": "evenodd"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}